'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = UIPage;

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ComponentWithBodyClass = require('../utils/ComponentWithBodyClass');

var _ComponentWithBodyClass2 = _interopRequireDefault(_ComponentWithBodyClass);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/**
 * Standard page container, setting classes, context, etc.
 */
function UIPage(props) {
  var bodyClassName = props.bodyClassName,
      bodyElement = props.bodyElement,
      className = props.className,
      TagName = props.tagName,
      rest = _objectWithoutProperties(props, ['bodyClassName', 'bodyElement', 'className', 'tagName']);

  var renderedChildren = _react2.default.createElement(TagName, _extends({}, rest, { className: (0, _classnames2.default)(className, 'private-page') }));

  if (bodyClassName) {
    return _react2.default.createElement(
      _ComponentWithBodyClass2.default,
      {
        bodyClassName: bodyClassName,
        bodyElement: bodyElement
      },
      renderedChildren
    );
  }

  return renderedChildren;
}

UIPage.propTypes = _extends({}, _ComponentWithBodyClass2.default.propTypes, {
  bodyClassName: _propTypes2.default.string,
  children: _propTypes2.default.node.isRequired,
  tagName: _propTypes2.default.string.isRequired
});

UIPage.defaultProps = _extends({}, _ComponentWithBodyClass2.default.defaultProps, {
  tagName: 'div'
});

UIPage.displayName = 'UIPage';
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3620/js/page/UIPage.js
// module id = 615
// module chunks = 177